"use client";

import type { ButtonHTMLAttributes, ReactNode } from "react";
import { cn } from "./cn";

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: ReactNode;
  label: string;
  touch?: boolean;
}

/** Icon-only button. `label` is mandatory: it becomes the accessible name and tooltip. */
export function IconButton({
  icon,
  label,
  touch = false,
  className,
  type = "button",
  title,
  ...rest
}: IconButtonProps) {
  return (
    <button
      type={type}
      className={cn("ui-icon-button", touch && "touch", className)}
      aria-label={label}
      title={title ?? label}
      {...rest}
    >
      <span aria-hidden="true">{icon}</span>
    </button>
  );
}
